import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/grapes/form'
import { api, actionCreators } from 'store/modules/grapes'

const metadata = {
  icon: 'pagelines',
  page: 'grapes',
  dialogSize: dialogSizes.LG
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
